import React, { useEffect, useState } from "react";
import ClientLayout from "../../../components/client/ClientLayout";
import RequireClientAdmin from "../../../components/client/RequireClientAdmin";
import DigitalCardTab from "../../../components/DigitalCardTab";
import { clientApi, clientApiAsAdmin } from "../../../api";

export default function SettingsDigitalCard() {
  const [venue, setVenue] = useState(null);
  const [litecardConfig, setLitecardConfig] = useState(null);

  useEffect(() => {
    let alive = true;
    Promise.all([
      clientApi.getMe(),
      clientApi.getLitecard(),
    ]).then(([me, lc]) => {
      if (!alive) return;
      setVenue(me.venue);
      setLitecardConfig(lc);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <ClientLayout>
      <RequireClientAdmin>
        <div className="venues-page-header">
          <div>
            <h1>Digital Card</h1>
            <p className="page-subtitle">Litecard template + field mapping</p>
          </div>
        </div>
        {venue && (
          <DigitalCardTab
            venueId={venue.id}
            venueName={venue.name}
            providerType={venue.provider_type || "s7000"}
            litecardConfig={litecardConfig}
            api={clientApiAsAdmin}
          />
        )}
      </RequireClientAdmin>
    </ClientLayout>
  );
}
